import NumericHelperService from "./numeric-helper.service";
import ObjectHelperService from "./object-helper.service";
import StringHelperService from "./string-helper.service";
import ArrayHelperService from "./array-helper.service";
import EnumHelperService from "./enum-helper.service";
import ParseCookieHelperService from "./parse-cookie-helper.service";
import { normalizeKeys } from "../data-normalization.service";


function useHelpers() {
  return {
    ...ArrayHelperService(),
    ...NumericHelperService(),
    ...StringHelperService(),
    ...ObjectHelperService(),
    ...EnumHelperService(),
    ...ParseCookieHelperService(),
    normalizeKeys
  }
}

export default useHelpers;